import { API_BASE_URL } from "../api/apiClient";

const ADMIN_BASE = "/api/admin/automotive";

async function parseJson(res) {
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Error de solicitud.");
  return data;
}

export function fetchAttributionReport(range = "last_30_days") {
  const qs = new URLSearchParams({ range }).toString();
  return fetch(`${API_BASE_URL}${ADMIN_BASE}/analytics/attribution?${qs}`, {
    credentials: "include",
  }).then(parseJson);
}

export { buildCampaignUrl } from "../utils/campaignAttribution";
